import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

import { FormFieldDropdown } from '~/components/FormField';
import { useIsExternalUser } from '~/hooks/useIsExternalUser.ts';
import { useOrganizationList } from '~settings/api/queries/organizationList';
import { toDropdownList } from '~settings/utils/transformers';

interface SelectOrganizationProps
  extends Omit<ComponentProps<typeof FormFieldDropdown>, 'label' | 'options'>,
    Partial<Pick<ComponentProps<typeof FormFieldDropdown>, 'label'>> {}

export function SelectOrganization({
  name,
  ...props
}: SelectOrganizationProps) {
  const { t } = useTranslation('settings', { keyPrefix: 'user' });

  const { organizationList } = useOrganizationList({
    enabled: !useIsExternalUser(),
    select: (data) => toDropdownList(data, 'title'),
  });

  return (
    <FormFieldDropdown
      label={t('fields.organization')}
      placeholder={t('placeholders.organization')}
      {...props}
      name={name}
      options={organizationList || []}
    />
  );
}
SelectOrganization.displayName = 'SelectOrganization';
